import React from "react";
import "./about.css";
import MATY1 from "../../assets/maty2.jpg";
import { FaAward } from "react-icons/fa";
import { FiUsers } from "react-icons/fi";
import { VscFolderLibrary } from "react-icons/vsc";

const About = () => {
  return (
    <section id="about">
      <h5>להכיר</h5>
      <h2>קצת עלי</h2>
      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={MATY1} alt="" />
          </div>
        </div>

        <div className="about__content">
          <div className="about__cards">
            {/*  */}
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>ניסיון</h5>
              <small> 2+ שנות ניסיון </small>
            </article>
            {/*  */}
            <article className="about__card">
              <FiUsers className="about__icon" />
              <h5>לקוחות</h5>
              <small> עשרות לקוחות מרוצים </small>
            </article>
            {/*  */}
            <article className="about__card">
              <VscFolderLibrary className="about__icon" />
              <h5>פרוייקטים</h5>
              <small> 30+ פרוייקטים </small>
            </article>
          </div>
          <p>
          מפתח אתרים ועצמאי עם ניסיון בשילוב אמנות העיצוב עם מיומנות של תכנות לספק חווית משתמש סוחפת ומרתקת באמצעות פיתוח אתרים יעיל, אופטימיזציה יזומה של תכונות ואיתור באגים בלתי פוסק. במהלך בניית האתר אני משלב את העיצובים הכי מתקדמים שיש המתאימים לכל עסק. החל מחנות צעצועים ועד לאתרי פיתוח ואפליקציות חכמות
          </p>

          <a href="#contact" className="btn btn-primary">
            צור קשר
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
